import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take, map, switchMap } from 'rxjs/operators';
import { get } from 'lodash';

import * as fromRoot from '../reducers';
import { GatingServices } from '../modules/core/services/gating.services';
import { CONSTANTS } from '../constants/constants';
import { FeatureFlagsService } from '../modules/core/services/feature-flags.service';
import { SetFeatureFlagsAction } from '../actions/feature-flags.actions';

export const featureFlagsResolver: ResolveFn<any> = (): Observable<boolean> | any => {
    const flagsService: FeatureFlagsService = inject(FeatureFlagsService);
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
    const constants: any = inject(CONSTANTS);
    const gatingService: GatingServices = inject(GatingServices);

    return store.pipe(
		select(fromRoot.getSessionState),
		take(1),
		switchMap(resData => {
			const departurePort = get(resData, 'reservationRetrievalResp.departurePortCode', constants.BOOKING_OFFICE.MIA);
			const reservationData = gatingService.getReservationData();
			return flagsService.initialize({...reservationData, departurePort}).pipe(
				take(1),
				map((flags: any) => {
					store.dispatch(new SetFeatureFlagsAction(flags));
					return true;
				})
			);
		})
	);
}